import React from "react";
import { Phone, Facebook, Instagram } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";
import VisitCounter from "./VisitCounter";

export default function TopBar() {
    const { t, lang, setLang } = useI18n();
    const { site } = useSite();
    const phones = site?.contact?.phones || [];
    const socials = site?.socials || {};
    return (
        <div className="bg-brand-navy text-white text-xs" data-testid="top-bar">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between gap-4">
                <span className="hidden sm:inline opacity-90">{t("topbar.welcome")}</span>
                <div className="flex items-center gap-4 ml-auto">
                    <div className="hidden md:flex items-center gap-2 text-white/90">
                        <Phone className="w-3.5 h-3.5 text-brand-gold" />
                        <span>{phones.map((p) => p.display).join(" / ")}</span>
                    </div>
                    <VisitCounter />
                    <div className="flex items-center gap-2">
                        {socials.facebook ? (
                            <a href={socials.facebook} target="_blank" rel="noreferrer" data-testid="top-fb" aria-label="Facebook" className="w-7 h-7 inline-flex items-center justify-center bg-white/10 hover:bg-brand-gold transition-colors">
                                <Facebook className="w-3.5 h-3.5" />
                            </a>
                        ) : null}
                        {socials.instagram ? (
                            <a href={socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="top-ig" className="w-7 h-7 inline-flex items-center justify-center bg-white/10 hover:bg-brand-gold transition-colors">
                                <Instagram className="w-3.5 h-3.5" />
                            </a>
                        ) : null}
                    </div>
                    <div className="flex items-center gap-1 pl-3 border-l border-white/20">
                        <button onClick={() => setLang("fr")} data-testid="lang-fr" className={`px-1.5 py-0.5 text-[0.68rem] tracking-wide font-semibold ${lang === "fr" ? "text-brand-gold" : "text-white/70 hover:text-white"}`}>FR</button>
                        <span className="text-white/30">|</span>
                        <button onClick={() => setLang("en")} data-testid="lang-en" className={`px-1.5 py-0.5 text-[0.68rem] tracking-wide font-semibold ${lang === "en" ? "text-brand-gold" : "text-white/70 hover:text-white"}`}>EN</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
